import Vue from 'vue'
import Vuex from 'Vuex' //需要安装npm i vuex//todo

Vue.use(Vuex);

var state = {
	//http:'http://djy.1942it.com:8087',//线上
//	http:'http://192.168.3.11:8080',//本地
	//http: 'http://www.1942it.com:8084', //测试(zkePA2)
	http: 'http://zkep2.1942it.com:8080', //正式（最后）(zkePA)
	//http: 'http://restest.380v.com',
	userName: '', //用户名
	token: '', //token
	permission: '', //权限
}

var getters = { //分发
	http: function(a) {
		return a.http;
	},
	userName: function(a) {
		return a.userName;
	},
	token: function(a) {
		return a.token;
	},
	permission: function(a) {
		return a.permission
	}
}

var mutations = { //更改
	user: function(a, b) {
		a.userName = b
	},
	token: function(a, b) {
		a.token = b
		window.localStorage["tokenApp"] = b;
	},
	permission: function(a, b) {
		a.permission = b
		window.localStorage["permissionApp"] = b;
	},
	companyId: function(a, b) {
		a.companyId = b

	}
}

var actions = { //异步
	user: function({
		commit
	}, b) {
		commit('user', b)
	},
	token: function({
		commit
	}, b) {

		commit('token', b)
	},
	permission: function({
		commit
	}, b) {

		commit('permission', b)
	}
}

export default new Vuex.Store({
	state,
	getters,
	mutations,
	actions
})


// WEBPACK FOOTER //
// ./src/store/index.js